import React from "react";

export const PhoneNumber = () => (
    <React.Fragment>
        <a href="tel:708-919-0241p4">708-919-0241 x4</a>
    </React.Fragment>
);
